import React, { useEffect, useState } from 'react';
import { Button, Space, Empty } from "antd";
import styles from "../../components/bulkDownload/FinancialYear.module.css";
import dayjs from 'dayjs';
import MyButtonWithCheckbox from './MyButtonWithCheckbox';
import FolderOutlineIcon from '../../components/icons/FolderOutlineIcons';

const generateYrs = (startDate = "2024-04-18T12:04:53.525697Z") => {
  const lstYrs = [];
  startDate = dayjs(startDate).utc(); // ✅ Use UTC
  const mth = startDate.month();
  const year = startDate.year();
  let strYr = mth > 2 ? year : year - 1;
  const endYr = dayjs().utc().month() > 2 ? dayjs().utc().year() + 1 : dayjs().utc().year();

  for (strYr; strYr < endYr; strYr++) {
    lstYrs.push(`${strYr}-${strYr + 1}`);
  }

  return lstYrs;
};

const getEnebleMonth = (dates) => {
  const yearMonthSet = new Set();
  dates.forEach(dateStr => {
    const date = dayjs(dateStr).utc(); // ✅ use UTC
    const monthKey = date.format("YYYY-MM");
    yearMonthSet.add(monthKey);
  });
  return Array.from(yearMonthSet);
};

export default function DownloadTab({ exuonDate, allExuonDate }) {
  const [selYr, setSelYr] = useState('');
  const [lstYrs, setLstYrs] = useState([]);
  const [enableMonths, setEnableMonths] = useState([]);

  useEffect(() => {
    setLstYrs(generateYrs(exuonDate));
    const data = getEnebleMonth(allExuonDate);
    setEnableMonths(data);
  }, []);

  const onYrClick = (yr) => {
    setSelYr(prev => (prev === yr ? null : yr));
  };

  return (
    <>
      {lstYrs.map((yr, ind) => (
        <div key={ind} className={styles.container}>
          <Space>
            <Button
              style={{
                backgroundColor: selYr === yr ? 'rgb(78, 54, 163)' : '',
                color: selYr === yr ? 'rgb(244, 244, 244)' : '',
                marginBottom: '10px',
              }}
              onClick={() => onYrClick(yr)}
              className="flex flex-row justify-center items-center"
            >
              <FolderOutlineIcon />
              {yr}
            </Button>
          </Space>
        </div>
      ))}

      {selYr ? (
        <MyButtonWithCheckbox enableMonths={enableMonths} financialYear={selYr} />
      ) : (
        <Empty description={<span style={{ color: 'gray' }}>Please select a year to see the data.</span>} />
      )}
    </>
  );
}
